import React from 'react';

import { Box, ButtonGroup } from '@mui/material';

import { FORM_FIELD_TYPES, FormField } from '../../../components/form/form-field';
import SaveButton from '../../../components/form/save-button';
import SchemaEditor from '../../../components/form/schema-editor';
import { useNodeContext } from '../../../context/node-context';

const Element451WriterForm = ({ form, onSubmit, onChange }) => {
  const { errors } = form.formState;
  const formControl = form.control;
  const { node } = useNodeContext();
  const { id } = node;

  return (
    <Box
      component="form"
      onSubmit={form.handleSubmit(onSubmit)}
      onReset={form.reset}
      onChange={onChange}
    >
      <FormField
        controlId="element451WriterFormName"
        label="name"
        name="name"
        control={formControl}
        fieldComponentType={FORM_FIELD_TYPES.TEXT}
        placeholder="Enter name"
        required
        error={errors.name?.message}
      />

      <FormField
        controlId="element451WriterFormType"
        label="type"
        name="type"
        control={formControl}
        fieldComponentType={FORM_FIELD_TYPES.TEXT}
        disabled
        error={errors.type?.message}
      />

      <FormField
        controlId="element451WriterFormDelayedRead"
        label="delayedRead"
        name="delayedRead"
        control={formControl}
        fieldComponentType={FORM_FIELD_TYPES.CHECKBOX}
      />

      <FormField
        controlId="element451WriterFormFormat"
        label="format"
        name="format"
        control={formControl}
        fieldComponentType={FORM_FIELD_TYPES.TEXT}
        error={errors.format?.message}
      />

      <FormField
        controlId="element451WriterFormOnError"
        label="onError"
        name="onError"
        control={formControl}
        fieldComponentType={FORM_FIELD_TYPES.SELECT}
        error={errors.onError?.message}
      >
        <option value="">Select On Error</option>
        <option value="continue">Continue</option>
        <option value="stop">Stop</option>
      </FormField>

      <FormField
        controlId="element451WriterFormClient"
        label="client"
        name="properties.client"
        control={formControl}
        fieldComponentType={FORM_FIELD_TYPES.TEXT}
        required
        error={errors.properties?.client?.message}
      />

      <FormField
        controlId="element451WriterFormApiRootUrl"
        label="apiRootUrl"
        name="properties.apiRootUrl"
        control={formControl}
        fieldComponentType={FORM_FIELD_TYPES.TEXT}
        error={errors.properties?.apiRootUrl?.message}
      />

      <FormField
        controlId="element451WriterFormSource"
        label="source"
        name="properties.source"
        control={formControl}
        fieldComponentType={FORM_FIELD_TYPES.TEXT}
        required
        error={errors.properties?.source?.message}
      />

      <FormField
        controlId="element451WriterFormTemplate"
        label="template"
        name="properties.template"
        control={formControl}
        fieldComponentType={FORM_FIELD_TYPES.TEXT}
        required
        error={errors.properties?.template?.message}
      />

      <FormField
        controlId="element451WriterFormFeature"
        label="feature"
        name="properties.feature"
        control={formControl}
        fieldComponentType={FORM_FIELD_TYPES.TEXT}
        required
        error={errors.properties?.feature?.message}
      />

      <FormField
        controlId="element451WriterFormSleepInMilliSeconds"
        label="sleepInMilliSeconds"
        name="properties.sleepInMilliSeconds"
        control={formControl}
        fieldComponentType={FORM_FIELD_TYPES.TEXT}
        type="number"
        error={errors.properties?.sleepInMilliSeconds?.message}
      />

      <SchemaEditor form={form} id={id} />

      <ButtonGroup>
        <SaveButton />
      </ButtonGroup>
    </Box>
  );
};

export default Element451WriterForm;
